import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from "../config/api";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

    useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await api.get(`blogs/${id}/`);
        setBlog(response.data);
      } catch (error) {
        console.error("Error fetching blog detail:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) return <p className="text-center mt-10">Loading blog...</p>;
  if (!blog) return <p className="text-center mt-10">Blog not found.</p>;

  return (
    <div className="max-w-3xl mx-auto py-10 px-4 bg-white shadow rounded">
      {blog.image && (
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-64 object-cover rounded mb-4"
        />
      )}
      <h1 className="text-3xl font-bold mb-2">{blog.title}</h1>
      <p className="text-sm text-gray-600 mb-4">
        By {blog.author || 'Admin'} on {new Date(blog.created_at).toLocaleDateString()}
      </p>
      <div className="text-gray-800 whitespace-pre-line leading-relaxed">{blog.content}</div>
    </div>
  );
};

export default BlogDetail;
